import type { IconData } from '@stacksjs/iconify-core'

export const airplaneModeOff: IconData = {
  "body": "<path fill=\"currentColor\" d=\"M224 113.889a73.24 73.24 0 0 1 26.423-56.413a8.71 8.71 0 0 1 11.154 0A73.24 73.24 0 0 1 288 113.889v92l165.914 82.957l-2.671 13.354l-86.936-11.339l37.114 37.112l75.336 9.827l13.329-66.646L320 186.111v-72.222a105.16 105.16 0 0 0-37.937-81a40.705 40.705 0 0 0-52.126 0a105.16 105.16 0 0 0-37.937 81v4.675l32 32ZM38.517 16H16.029v22.655L173 195.613L21.914 271.154L35.243 337.8l157.189-20.5l7.735 81.224L128 429.45V496h256v-66.55l-72.167-30.929l5.571-58.507L473.4 496H496v-22.542ZM352 450.55V464H160v-13.45l74.238-31.817L224 311.24v-30.332L60.757 302.2l-2.671-13.354l138.762-69.381L288 310.611v.629l-10.238 107.493Z\"/>",
  "width": 512,
  "height": 512,
  "viewBox": "0 0 512 512"
}

export default airplaneModeOff
